import React, { useEffect, useState } from 'react';
import { Card, Typography, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { getEstimateBilling } from '../../Billing/ducks/services';
import { normalizeEstimate } from '../../Billing/ducks/estimateBilling';
import moment from 'moment';

const { Title } = Typography;
const antIcon = <LoadingOutlined spin />;

const ProjectedInvoiceCard = ({ minHeight, cardStyle }) => {
  const [loading, setLoading] = useState(true);
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Get start and till date
        const startDate = moment().startOf('month').format('YYYY-MM-DD'); // eg: "2025-06-01"
        const endDate = moment().format('YYYY-MM-DD'); // today's date

        const response = await getEstimateBilling(startDate, endDate);
        const estimate = normalizeEstimate(response?.data?.body);
        setAmount(estimate?.invoiceAmount || 0);
      } catch (e) {
        setAmount(0);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Format as $1.5k, $2.1M, etc.
  const formatAmount = (val) => {
    if (val >= 1e6) return (val / 1e6).toFixed(1) + 'M';
    if (val >= 1e3) return (val / 1e3).toFixed(1) + 'k';
    return val.toLocaleString();
  };

  return (
    <Card
      className="custom-card-graph"
      title={<Title level={3}>Projected invoice amount to date</Title>}
      style={{ textAlign: 'left', width: '100%', ...cardStyle }}
      bodyStyle={{ minHeight: 390, display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px 10px', flexGrow: 1, width: '100%' }}>
        {loading ? (
          <Spin indicator={antIcon} style={{ fontSize: 32 }} />
        ) : (
          <>
            <span style={{ fontSize: 62, fontWeight: 900, color: '#111', fontFamily: 'Arial Black, Arial, sans-serif' }}>$ </span>
            <span
              style={{
                fontSize: 62,
                color: '#53aed8',
                fontFamily: `'Segoe UI', Roboto, Arial, sans-serif`,
                wordBreak: 'break-all',
              }}
            >
              {formatAmount(amount)}
            </span>
          </>
        )}
      </div>
      <style>{`
        @media (max-width: 600px) {
          .custom-card-graph .ant-typography, .custom-card-graph .ant-card-head-title {
            font-size: 16px !important;
          }
          .custom-card-graph span {
            font-size: 28px !important;
          }
        }
      `}</style>
    </Card>
  );
};

export default ProjectedInvoiceCard; 